module.exports = __webpack_public_path__ + "img/sceneBack.cbb656a9.png";